module.exports = __webpack_public_path__ + "img/95.6c9293fd.jpg";